<template>
  <div class="w-100">
    <nav v-if="editor" class="mb-0 navbar navbar-expand-lg navbar-light bg-light editor-tiptap-toolbar">
      <button class="nav-item" @click.prevent="editor.chain().focus().toggleBold().run()" :class="{ 'active': editor.isActive('bold') }">
        <i class="fas fa-bold"></i>
      </button>
      <button @click.prevent="editor.chain().focus().toggleItalic().run()" :class="{ 'active': editor.isActive('italic') }">
        <i class="fas fa-italic"></i>
      </button>
      <button @click.prevent="editor.chain().focus().setParagraph().run()" :class="{ 'active': editor.isActive('paragraph') }">
        <i class="fas fa-paragraph"></i>
      </button>
      <button @click.prevent="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'active': editor.isActive('heading', { level: 2 }) }">
        <i class="fas fa-heading"></i>
      </button>
      <button @click.prevent="editor.chain().focus().toggleBulletList().run()" :class="{ 'active': editor.isActive('bulletList') }">
        <i class="fas fa-list-ul"></i>
      </button>
      <button @click.prevent="editor.chain().focus().toggleOrderedList().run()" :class="{ 'active': editor.isActive('orderedList') }">
        <i class="fas fa-list-ol"></i>
      </button>
      <button @click.prevent="editor.chain().focus().setHorizontalRule().run()">
        <i class="fas fa-grip-lines"></i>
      </button>
      <button @click.prevent="editor.chain().focus().undo().run()">
        <i class="fas fa-undo"></i>
      </button>
      <button @click.prevent="editor.chain().focus().redo().run()">
        <i class="fas fa-redo"></i>
      </button>
    </nav>
    <editor-content :editor="editor" class="p-4 textarea" style="padding: 7px 10px!important;"/>
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'

export default {
  components: {
    EditorContent,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  watch: {
    value(value) {
      const isSame = this.editor.getHTML() === value

      if (isSame) {
        return
      }

      this.editor.commands.setContent(this.value, false)
    },
  },

  data() {
    return {
      editor: null,
    }
  },

  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
          StarterKit.configure({
              heading: {
                  levels: [2],
              },
          }),
      ],
      onUpdate: () => {
        this.$emit('input', this.editor.getHTML())
      }
    })
  },

  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>
<style lang="scss">
  .ProseMirror {
    min-height: 100px;
    overflow: scroll;
    &:focus {
      outline: none;
    }
  }
  .editor-tiptap-toolbar {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    border: 1px solid rgba(0,0,0,.125);

    + .textarea {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      border-top-color: transparent;
    }
  }
</style>
